import type {
    DateValidationError,
    PickerChangeHandlerContext,
} from '@mui/x-date-pickers';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { addDays, parseISO, startOfDay } from 'date-fns';
import { type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { updateEndDate } from '../helpers/statusModalHelpers';

type Props = {
    endDate?: string;
    setEndDate: Dispatch<SetStateAction<string | undefined>>;
    validationError: boolean;
    setValidationError: Dispatch<SetStateAction<boolean>>;
    disabled: boolean;
};

const DATE_DISPLAY_FORMAT = 'dd/MM/yyyy';

const FieldStatusExpirationPicker = ({
    endDate,
    setEndDate,
    validationError,
    setValidationError,
    disabled,
}: Props) => {
    const { t } = useTranslation();

    const isEndDateMissingForNewStatus = !endDate && !disabled;

    const tomorrow = addDays(startOfDay(new Date()), 1);
    const dateValue = endDate ? parseISO(endDate) : null;

    const onDateChange = (
        newValue: Date | null,
        context: PickerChangeHandlerContext<DateValidationError>,
    ): void => {
        const error = context.validationError ? true : false;
        setValidationError(error);
        updateEndDate(setEndDate, newValue);
    };

    const onDateAccept = (
        newValue: Date | null,
        _context: PickerChangeHandlerContext<DateValidationError>,
    ): void => {
        updateEndDate(setEndDate, newValue);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={t('dataCatalog.fieldStatusManagement.endDate')}
                value={dateValue}
                onChange={onDateChange}
                onAccept={onDateAccept}
                format={DATE_DISPLAY_FORMAT}
                minDate={tomorrow}
                disabled={disabled}
                slotProps={{
                    textField: {
                        error: validationError || isEndDateMissingForNewStatus,
                        helperText: validationError
                            ? 'Date invalide'
                            : isEndDateMissingForNewStatus
                              ? "Date d'expiration obligatoire"
                              : undefined,
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default FieldStatusExpirationPicker;
